import { Button, type ButtonProps } from 'antd';
import { type FC, Fragment, forwardRef } from 'react';

interface TextButtonProps extends ButtonProps {
  onClick?: () => void;
  dataTestId?: string;
}

const TextButton: FC<TextButtonProps> = forwardRef<HTMLButtonElement, TextButtonProps>(
  ({ children, icon = <Fragment />, onClick = () => {}, loading = false, disabled = false, htmlType }, ref) => {
    return (
      <Button
        disabled={disabled}
        className="d-flex align-items-center text-button"
        loading={loading}
        onClick={onClick}
        icon={icon}
        size="small"
        type="text"
        htmlType={htmlType}
        ref={ref}
      >
        {children}
      </Button>
    );
  },
);

TextButton.displayName = 'TextButton';

export default TextButton;
